import { connect } from 'react-redux';
// @ts-expect-error types missing
import FormField from './FormField';
// @ts-expect-error types missing
import { updateFormFieldDefinition } from 'FormsUI/actions/FormDefinition';
// @ts-expect-error types missing
import { removeFormField as removeFormFieldFromAction } from 'FormsUI/actions/FormDragDrop';
import { getFormFieldError, getIsRemovableField } from 'FormsUI/selectors/FormField';
import { UnknownProperties } from 'forms-utils-lib/constants/Properties';
import useTogglePayments from 'FormsUI/components/hooks/payment/useTogglePayments';
import useFieldInRouting from 'FormsUI/components/hooks/routing/useFieldInRouting';
import { jsx as _jsx } from "react/jsx-runtime";
const FormFieldContainer = ({
  formField,
  formFieldError,
  formFieldGroupIndex,
  formFieldIndex,
  formType,
  isRemovableField,
  groupHasRichText,
  handleDrag,
  handleInputSelect,
  numberFormFieldsWithinGroup,
  removeDependentField,
  removeFormField,
  selectedFieldName,
  showHighlightAnimation,
  updateFormField
}) => {
  const {
    objectTypeId,
    name
  } = formField;
  const {
    togglePaymentsOn
  } = useTogglePayments();
  const {
    isUsedInRouting,
    isDependentFieldUsedInRouting,
    removeRoutingFieldHandler
  } = useFieldInRouting({
    name,
    objectTypeId
  });
  const handleInputDelete = (sourceFormFieldGroupIndex, inputName, inputObjectTypeId) => {
    if (inputName === UnknownProperties.PAYMENT_LINK) {
      return togglePaymentsOn(false);
    }
    return removeFormField(sourceFormFieldGroupIndex, inputName, inputObjectTypeId);
  };
  return /*#__PURE__*/_jsx(FormField, {
    formField: formField,
    formFieldError: formFieldError,
    formFieldGroupIndex: formFieldGroupIndex,
    formFieldIndex: formFieldIndex,
    formType: formType,
    isRemovableField: isRemovableField,
    groupHasRichText: groupHasRichText,
    isUsedInRouting: isUsedInRouting,
    isDependentFieldUsedInRouting: isDependentFieldUsedInRouting,
    removeRoutingFieldHandler: removeRoutingFieldHandler,
    handleDrag: handleDrag,
    handleInputDelete: handleInputDelete,
    handleInputSelect: handleInputSelect,
    numberFormFieldsWithinGroup: numberFormFieldsWithinGroup,
    removeDependentField: removeDependentField,
    selectedFieldName: selectedFieldName,
    showHighlightAnimation: showHighlightAnimation,
    updateFormField: updateFormField
  });
};
const mapStateToProps = (state, {
  formField
}) => ({
  isRemovableField: getIsRemovableField(state, formField),
  formFieldError: getFormFieldError(state, formField)
});
const actionCreators = {
  removeFormField: removeFormFieldFromAction,
  updateFormField: updateFormFieldDefinition
};
export default connect(mapStateToProps, actionCreators)(FormFieldContainer);